<template>
  <div id="app">
    <div id="nav">
      <div class="logo">
        <img class="mobile" src="./assets/images/alfy-logo-100.png" alt="Alfy Isologo">
        <img class="desktop" src="./assets/images/alfy-logo-completo-300.png" alt="Alfy Isologo">
      </div>
    </div>
    <div id="spacer"></div>
    <div id="content">
      <div class="nav-text">
        <h2>Abrí tu cuenta</h2>
      </div>
      <Spinner v-show="isLoading"/>
      <div v-show="!isLoading">
        <NavDots :style="{display: navDotsStyleDisplay}" :screen=screenInt />
        <router-view :loggedIn=loggedIn :screen=screenInt :token=token :user=user :userData=userData @is-loading="setIsLoading" @update-user="updateUser" @user-data-updated="updateUserData" @update-user-token="updateUserToken" @advance-screen-protect="advanceScreen" @advance-screen="advanceScreenInt"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import qs from 'qs';
import CONSTANTS from '@/constants';
import NavDots from '@/components/NavDots.vue';
import Spinner from '@/components/Spinner.vue';

export default {
  name: 'app',
  components: {
    NavDots,
    Spinner,
  },
  data() {
    return {
      screenInt: 0,
      token: '',
      loggedIn: false,
      user: {},
      userData: {},
      removedNavDots: false,
      isLoading: true,
    };
  },
  computed: {
    navDotsStyleDisplay() {
      if (this.removedNavDots) {
        return 'none';
      }
      return 'block';
    },
  },
  watch: {
    loggedIn(newValue) {
      if (newValue) {
        localStorage.setItem('token', JSON.stringify(this.token));
        if (this.user === undefined) {
          console.log('Perfil de usuario es inexistente');
        }
        if (!(Object.entries(this.user).length === 0 && this.user.constructor === Object)) {
          if (this.user.screen_spot === 0) {
            this.screenInt = this.user.screen_spot + 1;
          } else {
            this.screenInt = this.user.screen_spot;
          }
        }
      } else {
        localStorage.clear();
      }
    },
    screenInt(newScreenSpot, oldScreenSpot) {
      console.log(`Screen Ints are: New -> ${newScreenSpot} and Old -> ${oldScreenSpot}`);
      if (newScreenSpot === 0) {
        this.updateScreenSpot(this.screenInt + 1);
      } else if (oldScreenSpot === 0) {
        this.updateScreenSpot(this.screenInt);
      } else if (oldScreenSpot !== 0 && newScreenSpot < 4) {
        this.updateScreenSpot(this.screenInt);
      } else if (newScreenSpot >= 4) {
        // console.log(this.screenInt);
        this.updateScreenSpot(this.screenInt);
      }
    },
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.token = JSON.parse(localStorage.getItem('token'));
      this.checkUserProfile();
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    toggleNavDots() {
      this.removedNavDots = true;
    },
    advanceScreen(integer) {
      if (integer) {
        switch (integer) {
          case 0:
            this.$router.push('');
            break;
          case 1:
            this.$router.push('document');
            break;
          case 2:
            this.$router.push('data');
            break;
          case 3:
            this.$router.push('additional');
            break;
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
            this.$router.push('thanks');
            break;
          default:
            break;
        }
      }
      this.isLoading = false;
    },
    advanceScreenInt(integer) {
      this.isLoading = true;
      if (integer) {
        this.screenInt = integer;
      } else {
        this.checkUserProfile();
      }
    },
    updateUserToken(token) {
      this.token = token;
    },
    setIsLoading(loading = true) {
      this.isLoading = loading;
    },
    updateUser(user) {
      this.user = user;
    },
    updateUserData(userData) {
      this.userData = userData;
    },
    updateScreenSpot(screenInt) {
      const data = JSON.stringify({ screen_spot: screenInt });
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user/profile/`,
      };
      // console.log(data);
      axios(options)
        .then((result) => {
          const user = result.data;
          this.user = user;
          this.advanceScreen(this.screenInt);
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('updateScreenSpot', { loggedIn: this.loggedIn, email });
        });
    },
    checkUserProfile() {
      const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user/profile/`,
      };
      axios(options)
        .then((result) => {
          const user = result.data.results[0];
          this.user = user;
          this.checkUserData();
          this.loggedIn = true;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            console.log('Unauthorized');
            let email = '';
            if (localStorage.getItem('email')) {
              email = JSON.parse(localStorage.getItem('email'));
            }
            this.$rollbar.info('checkUserProfile', { loggedIn: this.loggedIn, email });
            localStorage.clear();
          }
          console.log(error.response);
          this.isLoading = false;
        });
    },
    checkUserData() {
      const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/document-data/`,
      };
      axios(options)
        .then((result) => {
          const userData = result.data.results[0];
          this.userData = userData;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('checkUserData', { loggedIn: this.loggedIn, email });
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import './assets/css/css-resets.css';
@import './assets/fonts/fonts.css';
@import './assets/css/variables.scss';
@import url('https://fonts.googleapis.com/css?family=Lato:300,400,900');

#app {
  min-height: 100vh;
  background: #f9f9f9;
  @media screen and (min-width: $break-sm) {
    background-size: cover;
    background: url('./assets/images/alfy-background.jpg') no-repeat center center;
  }
  font-family: 'Lato',apple-system,BlinkMacSystemFont,"Segoe UI",
    Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
  font-variant-ligatures: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
a {
  color: #006bab;
}
#nav {
  text-align: left;
  background-color: $white;
  border-bottom: 1px solid #f5f5f5;
  @media screen and (min-width: $break-sm) {
    border-width: 4px;
    border-image: linear-gradient(90deg, $dark-blue, $dark-green) 1;
    text-align: center;
  }
  .logo {
    padding: 12px;
    @media screen and (min-width: $break-sm) {
      text-align: left;
      max-width: 1400px;
      margin: 0 auto;
      padding-top: 32px;
      padding-bottom: 18px;
    }
    img {
      max-width: 36px;

      &.desktop {
        display:none;
      }
      @media screen and (min-width: $break-sm) {
        max-width: 200px;

        &.desktop {
          display:block;
        }
        &.mobile {
          display:none;
        }
      }
    }
  }
  .logo, .nav-text {
    display: inline-block;
    vertical-align: middle;
    @media screen and (min-width: $break-sm) {
      display: block;
    }
  }
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#spacer {
  padding-top: 20px;
  @media screen and (min-width: $break-sm) {
    display: block;
  padding-top: 50px;
  }

}
#content {
  padding: 24px 0;
  @media screen and (min-width: $break-sm) {
    background: #fbfbfb;
    border-radius: 4px;
    box-shadow: 0px 6px 25px 0px rgba(51,51,51,0.3);
    max-width: 400px;
    min-height: 500px;
    margin: 0px auto;
    padding: 45px 30px;
  }

  .nav-text {
    font-weight: 400;
    font-size: 25px;
    @media screen and (min-width: $break-sm) {
      padding-left: 0px;
      margin: 12px 0;
      font-size: 36px;
    }
    h6 {
      @media screen and (min-width: $break-sm) {
        font-size: 28px;
      }
    }
  }

  .nav-dots {
    margin: 20px auto 20px;
    @media screen and (min-width: $break-sm) {
      margin: 16px auto 42px;
    }
  }
}
button, input {
  display: block;
  margin: 16px auto;
  width: 100%;
  box-sizing: border-box;
}

input {
  background: #fff;
  font-size: 18px;
  font-weight: 400;
  height: 46px;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 0px 16px;
  line-height: 1.33;
  border-radius: 4px;
  color: #3c3c3b;
  border: 1px solid #868686;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

input::placeholder {
  color: #c6c6c5;
}

input:focus {
  border-color: #62e676;
  outline: 0;
  box-shadow: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}

button {
  padding: 10px 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.33;
  height: 46px;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  background-color: $darker-blue;
  border-color: $darker-blue;
  letter-spacing: 1.6px;
  font-weight: 600;
}
button:active {
    background-image: none;
}
button:focus, button:active:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
}
button:hover, button:focus, button:active {
    color: #fff;
    background-color: $darker-green;
    border-color: $darker-green;
    text-decoration: none;
}
.error-message {
  color: #CC1111;
  margin: 12px auto;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.container {
  max-width: 300px;
  margin: 0 auto;
}
.spacer {
  margin: 12px;
}
.section {
  margin: 16px auto;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  display: block;
  margin: 16px auto;
  box-sizing: border-box;
  padding: 10px 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 8px;
  height: 46px;
  font-size: 13px;
  line-height: 2;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  background-color: $darker-blue;
  border-color: $darker-blue;
  letter-spacing: 1.6px;
  font-weight: 600;
  max-width: 282px;
}
.inputfile:focus + label, .inputfile:active:focus + label {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
}
.inputfile + label:hover, .inputfile:focus + label, label.with-file {
    color: #fff;
    background-color: $darker-green;
    border-color: $darker-green;
    text-decoration: none;
}
</style>
